import { render, staticRenderFns } from "./TileDataContentHeaderTwoColumn.vue?vue&type=template&id=d397f130&"
import script from "./TileDataContentHeaderTwoColumn.vue?vue&type=script&lang=js&"
export * from "./TileDataContentHeaderTwoColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports